import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Main Route
import Home from '@/components/Layouts/Home.vue'

// User Routes
import Login from '@/components/User/Login.vue'
//import Signup from '@/components/User/Signup.vue'
//import Register from '@/components/User/Register.vue'
import NewRegister from '@/components/User/NewRegister.vue'
import Forgot from '@/components/User/Forgot.vue'
//import Forgot from '@/components/User/Forgot.vue'
//import Reset from '@/components/User/Reset.vue'

// Account
import Account from '@/components/Layouts/Account.vue'
import EditPassword from '@/components/Layouts/EditPassword.vue'
import HelpCenter from '@/components/Layouts/HelpCenter.vue'

// Other
import NotFound from '@/components/Layouts/NotFound.vue'

import Lottery from '@/components/Layouts/Lottery.vue'
import Transaction from '@/components/Layouts/Transaction.vue'
import TransactionHistory from '@/components/Layouts/TransactionHistory.vue'
import LottoResultByDate from '@/components/Layouts/LottoResultByDate.vue'
import LottoResultByType from '@/components/Layouts/LottoResultByType.vue'
import Credit from '@/components/Layouts/Credit.vue'
import CreditHistory from '@/components/Layouts/CreditHistory.vue'
import Information from '@/components/Layouts/Information.vue'
import GetTransaction from '@/components/Layouts/GetTransaction.vue'
import Holding from '@/components/Layouts/Holding.vue'

// Gov lotto bet
import Govhome from '@/components/Gov/Govhome.vue'

// yeekee
import Allyeekee from '@/components/Yeekee/Allyeekee.vue'
import Yeekee from '@/components/Yeekee/Yeekee.vue'

// indexes
import Index from '@/components/Indexes/Index.vue'
import SpecialIndex from '@/components/Indexes/SpecialIndex.vue'


// request credit
import Reqcredit from '@/components/Reqcredit/Reqcredit.vue'
import Deposit from '@/components/Reqcredit/Deposit.vue'
import Withdraw from '@/components/Reqcredit/Withdraw.vue'

// affiliate
import Affiliate from '@/components/Affiliate/Affiliate.vue'
import AfMember from '@/components/Affiliate/AfMember.vue'
import AfRevenue from '@/components/Affiliate/AfRevenue.vue'
import AfWithdraw from '@/components/Affiliate/AfWithdraw.vue'

// numberset
import Numberset from '@/components/Numberset/NumberSet.vue'
import AddNumberset from '@/components/Numberset/AddNumberSet.vue'

import ChatView from '@/components/Chat/ChatView.vue'

// Non route compoinent registering
Vue.component('navbar', require('@/components/Partials/Navbar.vue').default)
//Vue.component('footer-main', require('@/components/Partials/Footer.vue').default)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            component: NotFound,
            name: 'notFound',
            meta: {title: 'Not Found'}
        },

        {
            path: '/',
            component: Login,
            name: 'login',
            meta: {title: 'เว็บหวยออนไลน์ที่ดีที่สุด'}
        },
        {
            path: '/index.html',
            component: Login,
        },
        {
            path: '/home',
            component: Home,
            name: 'home',
            meta: {title: 'Home', requiresAuth: true}
        },

        // {
        //     path: '/signup',
        //     component: Signup,
        //     name: 'signup',
        //     meta: {title: 'Signup'}
        // },

        /*
        {
            path: '/user/forgot',
            component: Forgot,
            name: 'forgot',
            meta: {title: 'Forgot'}
        },
        {
            path: '/user/reset',
            component: Reset,
            name: 'reset',
            meta: {title: 'Reset'}
        },
        */

        {
            path: '/account',
            component: Account,
            name: 'account',
            meta: {title: 'Account', requiresAuth: true}
        },
        {
            path: '/lottery',
            component: Lottery,
            name: 'lottery',
            meta: {title: 'Lottery', requiresAuth: true}
        },
        {
            path: '/transaction',
            component: Transaction,
            name: 'transaction',
            meta: {title: 'Transaction', requiresAuth: true}
        },
        {
            path: '/trans_history',
            component: TransactionHistory,
            name: 'trans_history',
            meta: {title: 'TransactionHistory', requiresAuth: true}
        },
        {
            path: '/lottoresultbydate',
            component: LottoResultByDate,
            name: 'lottoresultbydate',
            meta: {title: 'LottoResultByDate', requiresAuth: true}
        },
        {
            path: '/lottoresultbytype',
            component: LottoResultByType,
            name: 'lottoresultbytype',
            meta: {title: 'LottoResultByType', requiresAuth: true}
        },
        {
            path: '/reqcredit',
            component: Reqcredit,
            name: 'reqcredit',
            meta: {title: 'Reqcredit', requiresAuth: true}
        },
        {
            path: '/reqcredit/deposit',
            component: Deposit,
            name: 'deposit',
            meta: {title: 'Deposit', requiresAuth: true}
        },
        {
            path: '/reqcredit/withdraw',
            component: Withdraw,
            name: 'withdraw',
            meta: {title: 'Withdraw', requiresAuth: true}
        },
        {
            path: '/credit',
            component: Credit,
            name: 'credit',
            meta: {title: 'Credit', requiresAuth: true}
        },
        {
            path: '/credithistory',
            component: CreditHistory,
            name: 'credithistory',
            meta: {title: 'CreditHistory', requiresAuth: true}
        },


        {
            path: '/numberset',
            component: Numberset,
            name: 'numberset',
            meta: {title: 'Numberset', requiresAuth: true}
        },
        {
            path: '/numberset/addnumber',
            component: AddNumberset,
            name: 'addnumber',
            meta: {title: 'AddNumberset', requiresAuth: true}
        },


        {
            path: '/editpassword',
            component: EditPassword,
            name: 'editpassword',
            meta: {title: 'EditPassword', requiresAuth: true}
        },
        {
            path: '/helpcenter',
            component: HelpCenter,
            name: 'helpcenter',
            meta: {title: 'HelpCenter', requiresAuth: true}
        },
        {
            path: '/information',
            component: Information,
            name: 'information',
            meta: {title: 'Information', requiresAuth: true}
        },

        {
            path: '/govhome/:round',
            component: Govhome,
            name: 'govhome',
            meta: {title: 'Govhome', requiresAuth: true}
        },
        {
            path: '/getTransaction',
            component: GetTransaction,
            name: 'getTransaction',
            meta: {title: 'Get Transaction', requiresAuth: true}
        },
        {
            path: '/allyeekee',
            component: Allyeekee,
            name: 'allyeekee',
            meta: {title: 'All Yeekee', requiresAuth: true}
        },
        {
            path: '/yeekee/:round',
            component: Yeekee,
            name: 'yeekee',
            meta: {title: 'Yeekee', requiresAuth: true}
        },

        {
            path: '/index/:round',
            component: Index,
            name: 'index',
            meta: {title: 'Index', requiresAuth: true}
        },
        {
            path: '/spindex/:round',
            component: SpecialIndex,
            name: 'spindex',
            meta: {title: 'SpecialIndex', requiresAuth: true}
        },

        // {
        //     path: '/register/:parent_token',
        //     component: Register,
        //     name: 'register',
        //     meta: {title: 'Register'}
        // },

        {
            path: '/newregister/:parent_token',
            component: NewRegister,
            name: 'newregister',
            meta: {title: 'NewRegister'}
        },

        {
            path: '/forgot',
            component: Forgot,
            name: 'forgot',
            meta: {title: 'Forgot'}
        },

        {
            path: '/affiliate',
            component: Affiliate,
            name: 'affiliate',
            meta: {title: 'Affiliate', requiresAuth: true}
        },
        {
            path: '/affiliate/member',
            component: AfMember,
            name: 'af_member',
            meta: {title: 'AfMember', requiresAuth: true}
        },
        {
            path: '/affiliate/revenue',
            component: AfRevenue,
            name: 'af_revenue',
            meta: {title: 'AfRevenue', requiresAuth: true}
        },
        {
            path: '/affiliate/withdraw',
            component: AfWithdraw,
            name: 'af_withdraw',
            meta: {title: 'AfWithdraw', requiresAuth: true}
        },

        {
            path: '/holding',
            component: Holding,
            name: 'holding',
            meta: {title: 'Holding', requiresAuth: true}
        },
        {
            path: '/chat',
            component: ChatView,
            name: 'chat',
            meta: {title: 'Chat', requiresAuth: true}
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // Start our vue-progressbar
    router.app.$Progress.start()

    // To set the title of each route
    document.title = to.meta.title

    // Grab the accessToken and refreshToken. Dealing with the localStorage and Vuex has been tricky,
    // so we'll just set everything here at the top of the waterfall.
    let accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null
    let refreshToken = localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null

    // What we're accounting for is the instance of a reload, because up until then the user object will be
    // present if they've already logged in. So if an accessToken is present let's set the user object
    // and their access/refresh tokens.
    if (accessToken) {
        router.app.$options.store.dispatch('user/setUserAndTokens', {accessToken: accessToken, refreshToken: refreshToken})
    }

    // If the user's not logged in do not allow into protected pages.
    if (to.meta.requiresAuth && !router.app.$options.store.getters['user/user']) {
        return next({ name: 'login' })
    }
    next()

    // if ( process.env.VUE_APP_HOLDING_PAGE ) {

    //     // User's logged in and check for holding page is enabled?
    //     if ( router.app.$options.store.getters['user/user'] ) {

    //         router.app.$options.store.dispatch('information/getHoldingInfo').then((res) => {
    //             // console.log('current_res', res)
    //             if ( res ) {
    //                 return next({name: 'holding'})
    //             }
    //         })

    //     }

    // }

    next()
})

router.afterEach((to, from) => {
    // End our vue-progressbar
    router.app.$Progress.finish()
})

export default router
